import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PermissionsSwitchArrayComponent } from "./permissions-switch-array.component";
import { ActionButtonModule } from "../action-button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatFormFieldModule } from "@angular/material/form-field";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MultiStageExpansionPanelModule } from "../multi-stage-expansion-panel";

@NgModule({
    declarations: [
        PermissionsSwitchArrayComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatCheckboxModule,
        ActionButtonModule,
        MultiStageExpansionPanelModule
    ],
    exports: [
        PermissionsSwitchArrayComponent
    ]
})
export class PermissionsSwitchArrayModule { }
